import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetRepository =
  ApiClient['v1']['workspaces'][':workspaceId']['registry']['repositories'][':repositoryId']['$get'];
export type RepositoryResponseDetailed = InferResponseType<GetRepository, 200>;

export function useRepository(workspaceId: number, repositoryId: number) {
  return useFetch<RepositoryResponseDetailed>(
    `workspaces/${workspaceId}/repositories/${repositoryId}`,
    (client) =>
      client.v1.workspaces[':workspaceId'].registry.repositories[':repositoryId'].$get({
        param: {
          workspaceId: workspaceId.toString(),
          repositoryId: repositoryId.toString(),
        },
      })
  );
}
